module.exports = __webpack_public_path__ + "media/images/cureus_logo_large-ce305296a33d2309829a0591d4e528ea.png";